var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlutenIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.243,
    height: 66.542,
    viewBox: "0 0 66.243 66.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.121 1.795)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y2: 62,
    transform: "translate(0 0.626)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.7,107.507c-1.517-6.629-7.133-8.508-16.4-8.508-.006,8.59,4.327,11.72,12.462,12.441",
    transform: "translate(-302.308 -79.368)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.733,117.609A13.485,13.485,0,0,1,307.865,110a34.509,34.509,0,0,1,8.6.874",
    transform: "translate(-307.865 -74.943)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,95.223C296,88.684,301.609,85,301.609,85s5.609,3.684,5.609,10.223-5.609,10.812-5.609,10.812S296,101.763,296,95.223Z",
    transform: "translate(-281.977 -85)",
    fill: "none",
    stroke: "#e5b515",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.92 19.631)"
  }, /*#__PURE__*/React.createElement("line", {
    transform: "translate(0.08 30.995)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.239,100.174A31.243,31.243,0,0,1,302.826,99c.007,10.022-5.871,12.622-16.826,12.622a17.435,17.435,0,0,1,.59-4.8",
    transform: "translate(-263.562 -98.999)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.827,121c.006,10.021-5.873,12.621-16.827,12.621C285.993,123.6,291.871,121,302.827,121Z",
    transform: "translate(-263.563 -90.148)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,122.621C285.993,112.6,291.871,110,302.827,110,302.833,120.021,296.955,122.621,286,122.621Z",
    transform: "translate(-263.563 -94.573)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,119.679c2.816,1.593,6.784,2.165,11.858,2.165,0-4.887-1.4-8-4.107-9.916",
    transform: "translate(-297.03 -93.797)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,121c10.955,0,16.834,2.6,16.827,12.621-10.955,0-16.834-2.6-16.827-12.621",
    transform: "translate(-302 -90.148)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    y2: 29,
    transform: "translate(17.08 13.995)",
    fill: "none",
    stroke: "#e5b515",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenIcon);
export default __webpack_public_path__ + "static/media/gluten-icon.b56c5d7a.svg";
export { ForwardRef as ReactComponent };